module.exports = __webpack_public_path__ + "img/closeGroup.1563bff9.svg";